const state = {
  all: [],
  loading: false
}

export const getters = {}

export const mutations = {
  setAll(state, notifications) {
    state.all = JSON.parse(JSON.stringify(notifications))
    state.loading = false
  }
}

export const actions = {
  fetchAll({ state, commit }) {
    state.loading = true
    return api.getNotifications().then(
      ({ data }) => commit('setAll', data),
      ({ errors }) => {
        state.loading = false
        return errors
      }
    )
  },
  dismiss({ commit }, notification) {
    return api.patchNotificationDismiss(notification)
  }
}

export const api = {
  getNotifications: () => Vue.$http.get('candidate/notifications'),
  patchNotificationDismiss: notification => {
    return Vue.$http.patch(`candidate/notifications/${notification.id}`, { type: notification.type })
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
